import angular from 'angular';
import otherDirectCostsDetailsComponent from './other-direct-costs-details.component';

let otherDirectCostsDetailsModule = angular.module('otherDirectCostsDetails', [])
  .component('otherDirectCostsDetails', otherDirectCostsDetailsComponent);

export default otherDirectCostsDetailsModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/other-direct-costs-details/other-direct-costs-details.js